import { jsx as n } from "react/jsx-runtime";
import { a4 as p, d as r } from "../../vendor-CPVnY93G.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as i } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index17.css';const m = "_input_blniw_1", s = {
  input: m
};
function l({ className: t, ...o }) {
  return /* @__PURE__ */ n(
    p,
    {
      ...i(o),
      className: r(s.input, t),
      "data-component": "Input"
    }
  );
}
export {
  l as Input
};
